<template>
  <div class="login-box">
    <div class="inner">
        <div class="logo-box">
          <div class="logo" @click="backHome()"> <img src="//cdnw2.acmcoder.com/release/www/2.0.1/images/big-logo.png"/></div>
          <div class="logo-text">丈量，不可估量的未来</div>
          <div class="phone concat">
             <i class="iconfont icondianhua1"></i> <span v-html="webconfig.Landline">400-060-8006</span>
          </div>
        </div>
      <div class="login">
        <comp-info :toTab="toTab"></comp-info>
      </div>
    </div>
  </div>
</template>

<script>
import compInfo from '@/components/account/model/comp-info'
export default {
  components: {
    compInfo
  },
  data(){
      return {
          toTab:2,
          webconfig: {}
      }
  },
  computed: {
    loadConfig() {
      return this.$store.state.app.config
    }
  },
  mounted() {
    this.$bus.emit('loadSiteConfig')
    if(this.$store.state.app.config && this.$store.state.app.config.concat){
      this.webconfig = this.$store.state.app.config.concat
    }
  },
  watch: {
    loadConfig(newVal, oldVal) {
      if(newVal.concat){
        this.webconfig = newVal.concat
      }
    }
  },
  methods:{
    backHome(){
      this.$router.push({path:'/home'});
    }
  }
}
</script>

<style lang="scss" scoped>
  .login-box{
    border-top:6px solid #29bdb9;
    height:100%;
    display: block;
    background: #f7f8fd url('/static/images/bbg.png') repeat-x;
    .inner{
      width:640px;
      margin:0px auto;
      padding: 60px 0px 0px;
      .logo-box{
        padding: 0px 0px 50px;
        display: flex;
        .logo{
          cursor: pointer;
        }
        .logo-text{
          line-height: 60px; padding: 0px 10px 0px 25px;font-size:14px;
        }
        .concat{
          line-height: 60px;
          font-size: 15px;
          color: #29bdb9;
          padding: 0px 0px;
          width: 330px;
          text-align: right;
          float: right;
        }
      }
      .login{
        background: #fff;
        padding: 20px 0px 20px;
        margin:0px 100px 0px;
      }
    }
  }

  @media screen  and (max-width:600px){
    .login-box{
      .inner{
        padding: 0px 10px;
        width:initial;
        .logo-box{
          padding: 20px 0px;
          .concat{
            display: none;
          }
        }
        .login{
          padding: 20px 0px;
          margin:0px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/compInfo.vue